/* IMPORT */
import Interceptor from './interceptor.js';
/* MAIN */
const whenExit = Interceptor.register;
/* EXPORT */
export default whenExit;
